import { useGoalStatusSummaryGql } from '../../graphql';
import { useTeamTableContext } from '../../context/TeamTableContext';
import GoalsCol from '../GoalsCol';
import KeyResultsCol from '../keyResultsCol';

interface GoalsWithNestingProps {
  goalScope: 'CONTRIBUTOR' | 'TEAM';
  showGoal?: boolean;
  showKeyResult?: boolean;
  associatedIds?: string[];
  teamParentMap?: Record<string, string | null>;
  goalsTeamDataLoading?: boolean;
}

export const GoalsWithNesting = ({
  goalScope,
  associatedIds,
  showGoal = true,
  showKeyResult = true,
  goalsTeamDataLoading,
  teamParentMap,
}: GoalsWithNestingProps) => {
  const { data: goalStatusSummary, isFetching: goalStatusSummaryLoading } =
    useGoalStatusSummaryGql(goalScope, associatedIds || []);

  const { expanded } = useTeamTableContext();

  return (
    <>
      {showGoal && (
        <GoalsCol
          goalScope={goalScope}
          associatedIds={associatedIds}
          goalsTeamDataLoading={goalsTeamDataLoading}
          teamParentMap={teamParentMap}
          goalStatusSummary={goalStatusSummary || []}
          goalStatusSummaryLoading={goalStatusSummaryLoading}
          expanded={expanded}
        />
      )}
      {showKeyResult && (
        <KeyResultsCol
          goalScope={goalScope}
          associatedIds={associatedIds}
          goalsTeamDataLoading={goalsTeamDataLoading}
          teamParentMap={teamParentMap}
          goalStatusSummary={goalStatusSummary || []}
          goalStatusSummaryLoading={goalStatusSummaryLoading}
          expanded={expanded}
        />
      )}
    </>
  );
};

export default GoalsWithNesting;
